module.exports = __webpack_public_path__ + "static/desktop/img/flatbook.dfa1161b.jpg";